import Wrapper from "./Wrapper";
import Content from "./Content";

export default {
  Wrapper,
  Content
};
